import { ClinicianOptionFragment } from '@/components/clinicians/OptionalClinicianSelector';
import { gql } from '@apollo/client';

// The visit shape both month calendars render (episode calendar + rail)
export const CALENDAR_VISIT_FRAGMENT = gql`
    fragment CalendarVisit on Visit {
        id
        effectiveDate
        state
        outcome
        timezone
        disciplines {
            id
            code
        }
        clinicianAppointments {
            id
            startDatetime
            endDatetime
            services {
                id
                name
            }
            clinician {
                ...ClinicianOptionFragment
            }
        }
    }
    ${ClinicianOptionFragment}
`;
